// Rotas públicas de notas fiscais (impressões DANFE/CC-e, download de XML e visualização de XML).
// Migradas do submódulo f-erp-notas-fiscais (nfe/nfce/nfse) para o build principal do f-erp,
// pois usam paths de raiz (/nfe/danfe/:hash, /nfc/xml/:hash, /carta-correcao/:hash,
// /notas_fiscais/baixar_xml/:id, etc.) e precisam responder mesmo sem o submódulo carregado —
// o SPA do módulo (modules/fiscal) só atende paths sob /fiscal/. Apenas as rotas public:true.
//
// As impressões/downloads por :id (imprimir_cce, baixar_xml, imprimir_danfe) entram aqui porque
// o módulo as abre com :href em path de raiz (sem prefixo /fiscal/), caindo no build principal.
// Só a visualização de XML usa componente local (../components/VisualizacaoXml, self-contained,
// só @/shared); o resto usa os compartilhados Impressao/Download.
const routes = [
    // ===== NF-e =====
    {
        name: 'imprimirDanfeNotaFiscal',
        path: '/nfe/danfe/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: { fullScreen: true, public: true }
    },
    {
        name: 'imprimirDanfeSimplificadoNotaFiscal',
        path: '/nfe/danfe_simplificado/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: { fullScreen: true, public: true }
    },
    {
        name: 'imprimirCeeIdNotaFiscal',
        path: '/notas_fiscais/imprimir_cce/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: { fullScreen: true, public: true }
    },
    {
        name: 'imprimirCeeHashNotaFiscal',
        path: '/carta-correcao/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: { fullScreen: true, public: true }
    },
    {
        name: 'baixarXmlIdNotaFiscal',
        path: '/nfe/xml/:hash',
        component: () => import('@/shared/components/ui/Download'),
        meta: { public: true }
    },
    {
        name: 'baixarXmlHashNotaFiscal',
        path: '/notas_fiscais/baixar_xml/:id',
        component: () => import('@/shared/components/ui/Download'),
        meta: { public: true }
    },
    {
        name: 'visualizarXml',
        path: '/notas_fiscais/enviar_nota_fiscal/:id',
        component: () => import('../components/VisualizacaoXml'),
        meta: { public: true }
    },
    // ===== NFC-e (consumidor) =====
    {
        name: 'impressaoNfceHashNotasFiscaisConsumidores',
        path: '/nfc/danfe/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: { fullScreen: true, public: true }
    },
    {
        name: 'impressaoNfceIdNotasFiscaisConsumidores',
        path: '/notas_fiscais_consumidores/imprimir_danfe/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: { fullScreen: true, public: true }
    },
    {
        name: 'baixarXmlIdNotasFiscaisConsumidores',
        path: '/nfc/xml/:hash',
        component: () => import('@/shared/components/ui/Download'),
        meta: { public: true }
    },
    {
        name: 'baixarXmlHashNotasFiscaisConsumidores',
        path: '/notas_fiscais_consumidores/baixar_xml/:id',
        component: () => import('@/shared/components/ui/Download'),
        meta: { public: true }
    },
    {
        name: 'visualizarXmlNotaFiscalConsumidor',
        path: '/notas_fiscais_consumidores/enviar_nota_fiscal/:id',
        component: () => import('../components/VisualizacaoXml'),
        meta: { public: true }
    },
    // ===== NFS-e (serviço) =====
    {
        name: 'danfeNotaFiscalServico',
        path: '/nfse/danfe/:id',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: { public: true }
    },
    {
        name: 'xmlNotaFiscalServico',
        path: '/nfse/xml/:id',
        component: () => import('@/shared/components/ui/Download'),
        meta: { public: true }
    },
    {
        name: 'baixarXmlHashNotaFiscalServico',
        path: '/notas_fiscais_servicos/baixar_xml/:id',
        component: () => import('@/shared/components/ui/Download'),
        meta: { public: true }
    },
    {
        name: 'visualizarXmlNotaFiscalServico',
        path: '/notas_fiscais_servicos/enviar_nota_fiscal/:id',
        component: () => import('../components/VisualizacaoXml'),
        meta: { public: true }
    },
]

export default routes
